import Icon from "@visa/vds/icon";
import Td from "@visa/vds/td";
import Tr from "@visa/vds/tr";
import React, { useEffect, useState } from "react";
import { trackPromise } from "react-promise-tracker";
import MCSPagedTable from "../../../components/MCSPagedTable";
import { PageHelper } from "../../../_helpers/PageHelper";

const DafTabThreeRequestTable = (props) => {
  const dafUpload = props.dafUpload;
  const dafUploadId = dafUpload.id;
  const alertObj = props.alertObj;
  const fetchData = props.fetchData;
  const [selectedPage, setSelectedPage] = useState(1);
  const [sortBy, setSortBy] = useState("RecordNo");
  const [desc, setDesc] = useState(false);
  const [tableData, setTableData] = useState(null);
  const [totalPage, setTotalPage] = useState(0);
  const [totalCount, setTotalCount] = useState(0);
  const pageSize = 10;

  let colHeaders = [
    {
      displayName: "Record#",
      name: "RecordNo",
      orderable: true,
    },
    {
      displayName: "Visa Access User ID",
      name: "VolUserId",
      orderable: true,
    },
    {
      displayName: "VSS processing result",
      name: "ProcessResult",
      orderable: true,
    },
    {
      displayName: "Other Info",
      name: "OtherInfo",
      orderable: false,
    },
  ];

  const handleClickAction = (tabThreeRequest) => {
    props.handleClickAction(tabThreeRequest);
  };

  const fetch = async (page, sortBy, desc) => {
    let skipCount = PageHelper.GetSkipCount(pageSize, page);
    trackPromise(
      fetchData(dafUploadId, skipCount, sortBy, desc, pageSize)
        .then((result) => {
          var response = result.data;
          setTableData(response.items);
          setTotalCount(response.totalCount);
          setTotalPage(
            PageHelper.GetTotalCountToPages(pageSize, response.totalCount)
          );
        })
        .catch((error) => {
          if (alertObj) alertObj.setErrorMessage(error.message);
        })
    );
  };

  const handleSortChange = async (sortBy = null, desc = false) => {
    fetch(selectedPage, sortBy, desc);
  };

  const handlePageChange = (newPage) => {
    setSelectedPage(newPage);
    fetch(newPage, sortBy, desc);
  };

  useEffect(() => {
    fetch(selectedPage, sortBy, desc);
  }, []);

  return (
    <>
      <MCSPagedTable
        size={"compact"}
        colHeaders={colHeaders}
        usePagination={true}
        selectedPage={selectedPage}
        setSelectedPage={handlePageChange}
        totalPages={totalPage}
        pageSize={pageSize}
        totalCount={totalCount}
        ordered={sortBy}
        setOrdered={setSortBy}
        sortData={handleSortChange}
        isDsc={desc}
        setDsc={setDesc}
        tableData={
          tableData &&
          tableData.map((row, key) => (
            <Tr key={key}>
              <Td>{row.recordNo}</Td>
              <Td>{row.volUserId}</Td>
              <Td>{row.processResultName}</Td>
              <Td>
                <Icon
                  className="vss-clickable-icon"
                  name="info"
                  resolution="low"
                  onClick={() => handleClickAction(row)}
                />
              </Td>
            </Tr>
          ))
        }
      />
    </>
  );
};

export default DafTabThreeRequestTable;
